import React from 'react'
import type { BetLoopSharedBet } from '@core/Areas/BetLoop/types'
import { BetSelectionDisplay } from '@core/Areas/BetLoop/Components/Common/SharedBetCard/Components/BetSelectionDisplay'
import { PuntersCopiedLabel } from '@core/Areas/BetLoop/Components/Common/SharedBetCard/Components/PuntersCopiedLabel'
import { Header } from '@core/Areas/BetLoop/Components/Common/SharedBetCard/Components/Header'
import { CardContainer } from '@core/Areas/BetLoop/Components/Common/SharedBetCard/Components/CardContainer'
import { isKambiSharedCoupon } from '@core/Areas/BetLoop/helpers/typeGuards/isKambiSharedCoupon'
import { KambiBetSelectionDisplay } from '@core/Areas/BetLoop/Components/Common/SharedBetCard/Components/KambiBetSelectionDisplay'

export const BetLoopShare: React.FC<{ share: BetLoopSharedBet }> = ({ share }) => {
  return (
    <CardContainer headerSection={<Header sharedBet={share} isForExternalShare />}>
      {isKambiSharedCoupon(share.ticket) ? (
        <KambiBetSelectionDisplay coupon={share.ticket} isForExternalShare />
      ) : (
        <BetSelectionDisplay
          onPendingStatusChange={() => null}
          ticket={share.ticket}
          isResulted={share.isResulted}
          shouldDisableHeightTruncate
          isForExternalShare
        />
      )}

      <PuntersCopiedLabel copyCount={share.copyCount} shouldUseYourText={false} />
    </CardContainer>
  )
}
